export const ERR_NETWORK_CODE = 'ERR_NETWORK';
export const FILE_ERROR_CHUNK =
  'ответ сервера содержал пустое значение свойства "JsonData"';
export const NO_NAME_LABEL = 'Без имени';
export const FORBIDDEN_ERROR_MAIN_PART =
  'У вас нет прав доступа к этой части системы';

// Показывается вместо технического ответа инфраструктуры (страница 502/503/504
// от nginx, сетевая ошибка), пока бэкенд перезапускается при выкате.
export const SERVER_UNAVAILABLE_MESSAGE =
  'Сервер недоступен из-за установки обновлений. Повторите попытку через несколько секунд';
